import { SelectField, TextField, TextareaField } from "components/form/fields";
import { Column, Row, Section } from "components/layout";

import { TEXTS } from "../constants";
import { PROVIDER_FIELDS } from "../fields";

export function TiVoAppFormCspTab() {
  return (
    <Section header={TEXTS.SUPPORT.HEADER}>
      <Row>
        <Column>
          <SelectField {...PROVIDER_FIELDS.SUPPORT.PRIORITY} />
          <TextField {...PROVIDER_FIELDS.SUPPORT.EMAIL} />
          <TextField {...PROVIDER_FIELDS.SUPPORT.PHONE} />
        </Column>
        <Column>
          <TextareaField {...PROVIDER_FIELDS.SUPPORT.NOTES} />
          <TextareaField {...PROVIDER_FIELDS.SUPPORT.SLA} />
          <TextareaField {...PROVIDER_FIELDS.SUPPORT.CONTACTS} />
        </Column>
      </Row>
    </Section>
  );
}
